<template>
  <div class="pop-up-wrap-user">
    <div class="pop-up-user button-wrap button-wrap2">
      <div class="pop-header-user">
        <span class="title02">클레임</span>
        <button
          class="btn-pop-close"
          id="btnClosePopup"
          @click="this.$emit('close')"
        >
          닫기<span class="overlay"></span>
        </button>
      </div>
      <div class="pop-btn-list btn-grid">
        <button
          type="button"
          class="btn-pop btn-main"
          @click="setClaim('오주문')"
        >
          오주문<span class="overlay"></span>
        </button>
        <button
          type="button"
          class="btn-pop btn-main"
          @click="setClaim('가격불만')"
        >
          가격불만<span class="overlay"></span>
        </button>
        <button
          type="button"
          class="btn-pop btn-main"
          @click="setClaim('서비스불만')"
        >
          서비스불만<span class="overlay"></span>
        </button>
        <button type="button" class="btn-pop btn-main">
          <span class="overlay"></span>
        </button>
        <button type="button" class="btn-pop btn-main">
          <span class="overlay"></span>
        </button>
        <button type="button" class="btn-pop btn-main">
          <span class="overlay"></span>
        </button>
        <button type="button" class="btn-pop btn-main">
          <span class="overlay"></span>
        </button>
        <button type="button" class="btn-pop btn-main">
          <span class="overlay"></span>
        </button>
        <button type="button" class="btn-pop btn-main">
          <span class="overlay"></span>
        </button>
        <button type="button" class="btn-pop btn-main">
          <span class="overlay"></span>
        </button>
      </div>
      <div class="input-wrap">
        <textarea
          id="customerMemo"
          placeholder="고객요청과 컴플레인 사항들을 메모에 남겨주세요."
        ></textarea>
        <button
          type="button"
          id="btnApply"
          class="btn-pop btn-main"
          @click="setClaim('input')"
        >
          직접등록<span class="overlay"></span>
        </button>
      </div>
    </div>
    <div class="dimed"></div>
  </div>

  <PopupBtn2
    v-if="isPopupBtn2"
    :popupText="popupText"
    :popupTitle="popupTitle"
    @close="isPopupBtn2 = false"
    @setYes="setYes"
  />
</template>

<script>
import popupBtn2 from "@/components/popup/PopupBtn2.vue";

export default {
  name: "claim",
  props: {},
  data() {
    return {
      isPopupBtn2: false,
      popupText: "",
      popupTitle: "안내",
      message: "",
    };
  },
  methods: {
    setClaim(msg) {
      if (msg == "input") {
        msg = document.getElementById("customerMemo").value;
      }
      if (msg.length == 0) return;

      this.popupText = "고객 클레임정보(" + msg + ")를 저장하시겠습니까?";
      this.isPopupBtn2 = true;
      this.message = msg;
    },
    setYes() {
      this.isPopupBtn2 = false;
      this.$emit("claimNotice", this.message);
    },
  },
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {
    PopupBtn2: popupBtn2,
  },
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped>
</style>


